export default __webpack_public_path__ + "static/media/favicon.c7fc6edc.ico";